import styled from "styled-components";
import { Spacer } from "../editor/EditorHelpers";
import { Button } from "./Button";
import { ReactNode } from "react";
import { FiX } from "react-icons/fi";



export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(32, 32, 32, 0.35);
  z-index: 999;
`;

export const ModalWrapper = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  z-index: 1000;
`;

export const Modal = styled.div`
  background: var(--bg-color);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  padding: 0rem;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
`;

interface ModalHeaderProps {
  children: ReactNode;
  onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ children, onClose }) => {
  return (
    <ModalHeaderContainer>
      {children}
      <Spacer style={{flexGrow: 1}} />
      <Button $borderless onClick={onClose} style={{ color: 'var(--text-color)'}}>
          <FiX size={18} style={{ verticalAlign: 'middle' }} />
      </Button>
    </ModalHeaderContainer>
  );
}

export const ModalScrollview = styled.div`
  max-height: 65vh;
  overflow-y: auto;
`

export const ModalHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  margin: 1rem 1.5rem 0.75rem 2rem;

  font-weight: 600;
`

